(function(){'use strict';

function isFr(){return(document.documentElement.lang||'').indexOf('fr')===0;}
function t(en,fr){return isFr()?fr:en;}

/* ── Patch /collections links to homepage ── */
function patchLinks(){
  document.querySelectorAll('a[href="/collections"],a[href="/collections/"],a[href="/collections/all"],a[href="/collections/all/"]').forEach(function(a){a.href='/';}); 
  document.querySelectorAll('.cart-items__empty-button').forEach(function(b){b.href='/';}); 
  document.querySelectorAll('.oh-coll__empty .oh-coll__btn').forEach(function(b){b.href='/';}); 
}

/* ── Our story link below brand story pillars ── */
function injectAboutLink(){
  document.querySelectorAll('.bs__pillars').forEach(function(pillars){
    if(pillars.parentElement.querySelector('.bs__about-link-wrap'))return;
    var d=document.createElement('div');d.className='bs__about-link-wrap';
    var a=document.createElement('a');a.href='/pages/about';a.className='bs__about-link';
    a.textContent=isFr()?'Notre histoire \u2192':'Our story \u2192';
    d.appendChild(a);pillars.after(d);
  });
}

function init(){
  patchLinks();
  injectAboutLink();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}

})();
